import { useHistory } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUDIENCE } from 'env'

const Auth0ProviderWithHistory = ({ children }) => {
  const history = useHistory();
  const domain = AUTH0_DOMAIN;
  const clientId = AUTH0_CLIENT_ID;
  const audience = AUDIENCE;

  const onRedirectCallback = (appState) => {
    history.push(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
      audience={audience}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;